<template>
  <header id="header"
          :class="{'header-opacity': scrolledHeader, 'fadeOut': !show, 'fadeIn': show, 'disNone': disNone}"
          class="animated animated-header">
    <div class="header-icon">
      <b-img :src="require('@/assets/images/wegow-conciertos.svg')"
             class="logo-wegow"
             alt="Conciertos Wegow"
             fluid />
    </div>
  </header>
</template>

<script>
export default {
  data: () => ({
    scrolledHeader: false,
    windowWidth: 0,
    lastScroll: 0,
    show: true,
    disNone: false
  }),
  computed: {
    getWidth() {
      return this.windowWidth
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
    this.handleResize()
    this.handleScroll()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    handleScroll() {
      this.scrolledHeader = false
      this.show = true
      var currentScroll = window.scrollY
      if (currentScroll > this.lastScroll && currentScroll > 72) {
        this.show = false
        setTimeout(() => {
          this.disNone = true
        }, 1000)
      } else if (currentScroll < this.lastScroll && currentScroll > 72) {
        this.scrolledHeader = true
        this.show = true
        setTimeout(() => {
          this.disNone = false
        }, 1000)
      } else if (currentScroll < this.lastScroll && currentScroll < 72) {
        this.scrolledHeader = false
        this.show = true
        setTimeout(() => {
          this.disNone = false
        }, 1000)
      }
      this.lastScroll = currentScroll
    }
  }
}
</script>

<style lang="scss">
@import './top-header.sass';
@import './dropdown-menu.sass';
</style>
